export const SET_PARAM_KEY = 'SET_PARAM_KEY'
export const SET_RECRUITER_DESTINATION_CANDIDATE_TARGET = 'SET_RECRUITER_DESTINATION_CANDIDATE_TARGET'
export const SET_TAG_DESTINATION_CANDIDATE_TARGET = 'SET_TAG_DESTINATION_CANDIDATE_TARGET'

export const CANCEL_FETCH_RECRUITER = 'CANCEL_FETCH_RECRUITER'
export const FAILURE_FETCH_RECRUITER = 'FAILURE_FETCH_RECRUITER'
export const START_FETCH_RECRUITER = 'START_FETCH_RECRUITER'
export const SUCCESS_FETCH_RECRUITER = 'SUCCESS_FETCH_RECRUITER'
export const MOVE_RECRUITER_PAGE = 'MOVE_RECRUITER_PAGE'
export const CHANGE_RECRUITER_KEYWORD = 'CHANGE_RECRUITER_KEYWORD'

export const CANCEL_FETCH_TAG = 'CANCEL_FETCH_TAG'
export const FAILURE_FETCH_TAG = 'FAILURE_FETCH_TAG'
export const START_FETCH_TAG = 'START_FETCH_TAG'
export const SUCCESS_FETCH_TAG = 'SUCCESS_FETCH_TAG'
export const MOVE_TAG_PAGE = 'MOVE_TAG_PAGE'
export const CHANGE_TAG_KEYWORD = 'CHANGE_TAG_KEYWORD'

export const FAILURE_FETCH_SPECIAL = 'FAILURE_FETCH_SPECIAL'
export const START_FETCH_SPECIAL = 'START_FETCH_SPECIAL'
export const SUCCESS_FETCH_SPECIAL = 'SUCCESS_FETCH_SPECIAL'
